module.exports = __webpack_public_path__ + "img/1-January.7449368a.jpg";